module.exports = __webpack_public_path__ + "static/media/logocircle.1d7bafbe.svg";